module.exports = __webpack_public_path__ + "static/media/7-7.2abf51c8.mp3";